import React from "react";
import { Link } from "react-router-dom";
import useLanguage from "./../hooks/useLanguage";

const NewsCard = ({ data }) => {
  const lng = useLanguage();
  return (
    <>
      <div className="col-xl-3 col-6">
        <div className="news-card">
          {/* News pictures hidden (Nov 2026) — uncomment to restore the cover.
          <img src={data.image} alt="" className="title-img" /> */}
          <div className="card_body">
            {data.translation.map((translation, i) => { 
              if(translation.language.toLowerCase() === lng){
                return <h3>{translation.title}</h3>
              }else{
                return (null)
              }
               
            })}
            
            <ul className="date-view">
              <li>{(data.date || data.data) ? new Date(data.date || data.data).toLocaleDateString('it-IT') : ''}</li>
            </ul>
            <Link to={`/${lng}/news/${data.id}`} className="btn cta-secondary">
              Leggi la news
            </Link>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default NewsCard;